export default __webpack_public_path__ + "static/media/sch8_w640.b5d237a3.jpg";